export const fetchUrl = process.env.NODE_ENV === 'production' ? '/api/' : 'http://localhost:8000/api/'
export const fetchClientZoneUrl = process.env.NODE_ENV === 'production' ? '/api/cl/' : 'http://localhost:8000/api/cl/'
export const mediaUrl = process.env.NODE_ENV === 'production' ? '/media/' : 'http://localhost:8000/media/'

// export const fetchUrl = process.env.NODE_ENV === 'production' ? '/api/' : 'https://mwg.incrm.cz/api/'